import getVisibleChildrenWithoutGroups from './getVisibleChildrenWithoutGroups';
export const getCurrentlyVisibleNavItems = (navItems, nextActiveItem) => {
  const {
    primary,
    secondary
  } = navItems.openMenus;
  const activeNavItem = nextActiveItem || primary;
  if (!activeNavItem) return [];
  const visibleNavItems = getVisibleChildrenWithoutGroups(navItems.byId[activeNavItem]);
  for (const openSecondaryMenu of secondary) {
    const indexOfOpenSecondaryMenu = visibleNavItems.findIndex(navItem => navItem.id === openSecondaryMenu);
    if (indexOfOpenSecondaryMenu !== -1) {
      visibleNavItems.splice(indexOfOpenSecondaryMenu + 1, 0, ...navItems.byId[openSecondaryMenu].children);
    }
  }
  return visibleNavItems;
};
export default getCurrentlyVisibleNavItems;